module.exports = __webpack_public_path__ + "img/guidelines-04.d5ba32e0.png";